import { render, staticRenderFns } from "./SidebarRequests.vue?vue&type=template&id=130c5d4c&scoped=true"
import script from "./SidebarRequests.vue?vue&type=script&lang=js"
export * from "./SidebarRequests.vue?vue&type=script&lang=js"
import style0 from "./SidebarRequests.vue?vue&type=style&index=0&id=130c5d4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130c5d4c",
  null
  
)

export default component.exports